var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"stream-preview"},[_c('aside',[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.close}},[_c('close-icon')],1)],1),_c('main',[_c('video',{staticClass:"video-preview video-js vjs-4-3 vjs-big-play-centered",attrs:{"id":_vm.videoId,"controls":"","autoplay":"","playsinline":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }